import { render, staticRenderFns } from "./PremiumSurveyRangeAnswer.vue?vue&type=template&id=046e61d1&scoped=true"
import script from "./PremiumSurveyRangeAnswer.vue?vue&type=script&lang=js"
export * from "./PremiumSurveyRangeAnswer.vue?vue&type=script&lang=js"
import style0 from "./PremiumSurveyRangeAnswer.vue?vue&type=style&index=0&id=046e61d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046e61d1",
  null
  
)

export default component.exports